const parseToObject = (input) => {
  let normalizedInput = input.trim().replace(/^\[/, "[").replace(/^\{/, "{").replace(/\]$/, "]").replace(/\}$/, "}").replace(/([\w\d_]+)\s*:/g, '"$1":').replace(/:\s*([a-zA-Z_][\w\d_]*)/g, ': "$1"');
  normalizedInput = normalizedInput.replace(
    /\[([^\[\]]+?)\]/g,
    (_match, arrayContent) => {
      const newContent = arrayContent.split(",").map((item) => {
        const trimmed = item.trim();
        if (trimmed.startsWith('"') && trimmed.endsWith('"') || !isNaN(Number(trimmed))) {
          return trimmed;
        }
        return `"${trimmed}"`;
      }).join(", ");
      return `[${newContent}]`;
    }
  );
  return JSON.parse(normalizedInput);
};
const getMarkdownMetadata = (markdown) => {
  try {
    const lines = markdown.split(/\r?\n/);
    const firstNonEmptyLine = lines.find((line) => line.trim() !== "");
    if (!firstNonEmptyLine || firstNonEmptyLine.trim() !== "---") {
      const result = {};
      return result;
    }
    const metadata = {};
    let inMetadataBlock = false;
    let currentKey = null;
    let currentArrayItems = [];
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const trimmedLine = line.trim();
      if (trimmedLine === "---") {
        if (!inMetadataBlock) {
          inMetadataBlock = true;
          continue;
        } else {
          if (currentKey && currentArrayItems.length > 0) {
            metadata[currentKey] = currentArrayItems;
          }
          break;
        }
      }
      if (inMetadataBlock) {
        const arrayItemMatch = line.match(/^\s*-\s+(.+)$/);
        if (arrayItemMatch && currentKey) {
          currentArrayItems.push(arrayItemMatch[1].trim());
          continue;
        }
        if (currentKey && currentArrayItems.length > 0) {
          metadata[currentKey] = currentArrayItems;
          currentKey = null;
          currentArrayItems = [];
        }
        const match = line.match(/^([^:]+)\s*:\s*(.*)$/);
        if (match) {
          const key = match[1].trim();
          const value = match[2].trim();
          if (value === "") {
            currentKey = key;
            currentArrayItems = [];
          } else {
            try {
              metadata[key] = parseToObject(value);
            } catch (e) {
              metadata[key] = value;
            }
          }
        }
      }
    }
    return metadata;
  } catch (e) {
    const result = {};
    return result;
  }
};
export {
  getMarkdownMetadata
};
//# sourceMappingURL=getMarkdownMetadata.mjs.map